import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";

export class AppTypeCollection extends CachingCollection<Backbone.Model> {
    url = () => {
        return window.location.origin + '/api/v1/apps/types';
    };

    comparator = (model) => {
        return model.get('name');
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/AppTypes.ts